<script>
'use strict';

const StoryList = require('./StoryList.vue');
const SkeletonStoryCard = require('./SkeletonStoryCard.vue');

const SKELETON_STORY_COUNT = 5;

module.exports = {
  name: 'StoriesSection',
  components: {
    StoryList,
    SkeletonStoryCard,
  },
  data() {
    return {
      skeletonStoryCount: SKELETON_STORY_COUNT,
    };
  },
  computed: {
    stories() {
      return this.$store.state.storyResults;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
};
</script>

<template>
  <div class="stories-section">
    <div class="story-list" v-if="loading" aria-busy="true">
      <SkeletonStoryCard v-for="n in skeletonStoryCount" :key="`s-${n}`" />
    </div>
    <StoryList v-else :stories="stories" context="stories-tab" />
  </div>
</template>

<style scoped lang="postcss"></style>
